module.exports = __webpack_public_path__ + "img/notice.b408440a.png";